import type { Position } from 'components/map/types';

// Brings the supported item formats [lat, lng], { position: [lat, lng] } and { latitude, longitude } into [lat, lng]
const toTuple = (item: unknown): unknown[] | undefined => {
    if (Array.isArray(item)) return item;
    if (typeof item !== 'object' || item === null) return;
    if ('position' in item && Array.isArray(item.position)) return item.position;
    if ('latitude' in item && 'longitude' in item) return [item.latitude, item.longitude];
    return;
};

export function parseWaypoints(input: string): Position[] {
    let parsed: unknown;
    try {
        parsed = JSON.parse(input);
    } catch {
        throw new Error('Invalid JSON');
    }

    if (!Array.isArray(parsed) || parsed.length === 0) {
        throw new Error('Expected a non-empty JSON array');
    }

    return parsed.map((item: unknown, i) => {
        const tuple = toTuple(item);
        if (!tuple) {
            throw new Error(`Item ${i}: expected [lat, lng], { position: [lat, lng] } or { latitude, longitude }`);
        }
        const [lat, lng] = tuple;
        if (typeof lat !== 'number' || typeof lng !== 'number') throw new Error(`Item ${i}: lat/lng must be numbers`);
        if (Math.abs(lat) > 90) throw new Error(`Item ${i}: latitude ${lat} out of range (-90..90)`);
        if (Math.abs(lng) > 180) throw new Error(`Item ${i}: longitude ${lng} out of range (-180..180)`);
        return { lat, lng };
    });
}
